export default __webpack_public_path__ + "static/media/crit_thinking.ab5b6935.svg";